import { __spreadArrays } from "tslib";
import { GALLERY_CONSTS } from 'pro-gallery-lib';
export var getSlideAnimationClassNames = function (_a, overrideDeckTransition) {
    var idx = _a.idx, activeIndex = _a.activeIndex, options = _a.options;
    if (overrideDeckTransition === void 0) { overrideDeckTransition = false; }
    var isRTL = options.isRTL, slideAnimation = options.slideAnimation;
    switch (slideAnimation) {
        case GALLERY_CONSTS.slideAnimations.FADE:
            return "fade fade-" + (activeIndex === idx ? 'visible' : 'hidden');
        case GALLERY_CONSTS.slideAnimations.DECK: {
            if (activeIndex < idx) {
                return "deck-after " + (overrideDeckTransition ? 'override' : '');
            }
            else if (activeIndex === idx) {
                return "deck-current " + (overrideDeckTransition ? 'override' : '');
            }
            else if (activeIndex > idx) {
                return "deck-before" + (isRTL ? '-rtl' : '');
            }
            return {};
        }
        default:
            return {};
    }
};
export var toggleScrollLessAnimation = function (callback) {
    var toggleDeckTransitions = function (isPaused) {
        console.log('toggleScrollLessAnimation: ', isPaused);
        ['.gallery-item-wrapper', '.gallery-item-common-info-outer'].forEach(function (className) {
            if (isPaused) {
                __spreadArrays(document.querySelectorAll(className)).forEach(function (item) {
                    var _a;
                    (_a = item.classList) === null || _a === void 0 ? void 0 : _a.add('disabled-transition');
                });
            }
            else {
                __spreadArrays(document.querySelectorAll(className)).forEach(function (item) {
                    var _a;
                    // item.offsetHeight; is to trigger a reflow and flush all the CSS changes.
                    item.offsetHeight;
                    (_a = item.classList) === null || _a === void 0 ? void 0 : _a.remove('disabled-transition');
                });
            }
        });
    };
    setTimeout(function () {
        callback && callback();
        toggleDeckTransitions(true);
        toggleDeckTransitions(false);
    }, 600);
};
//# sourceMappingURL=scrollLessAnimationHelper.js.map